<template lang="pug">
.sell-records
  HScroll(:currentStep='currentStep')
    transition(name='simple-fade' mode='out-in')
      //- STEP 1 (always visible)
      ActionSelectorMenu(:items='actionItems' v-model='actionType')

    transition(name='simple-fade' mode='out-in')
      //- STEP 2 (visible if actionType is selected)
      div(v-if='actionType')
        template(v-if='actionType === "SELL_LIST"')
          CSSellList(:preSelectedOrder='preSelectedOrder')
        template(v-else-if='actionType === "ADMIN_APPROVAL_LIST"')
          CSAdminApprovalList
        template(v-else-if='actionType === "OUTSTANDING_LIST"')
          CSOutstandingList
        template(v-else-if='actionType === "BACKORDER_LIST"')
          CSBackOrderList

        template(v-else)
          GenericCard.actionDetail(size='33')
            .d-flex.flex-column.px-3.py-4
              h5 {{ actionType }}

</template>

<script>
import CSSellList from '@/components/_cs/sell-records/panels/CSSellList.vue';
import CSAdminApprovalList from '@/components/_cs/sell-records/panels/CSAdminApprovalList.vue';
import CSOutstandingList from '@/components/_cs/sell-records/panels/CSOutstandingList.vue';
import CSBackOrderList from '@/components/_cs/sell-records/panels/CSBackOrderList.vue';

export default {
  data: () => ({
    actionType: null,
    checkinActionType: null,
    // actionDetail: null,
    currentStep: 0,

    filterProvince: '',

    STEP_SELECT_ACTION: 1,

    actionItems: {
      SELL_LIST: 'ดูรายการขาย',
      ADMIN_APPROVAL_LIST: 'ดูรายการส่งต่อแอดมิน',
      OUTSTANDING_LIST: 'ดูรายการค้างชำระ',
      BACKORDER_LIST: 'ดูรายการ Back Order',
    },

    preSelectedOrder: null,
  }),
  watch: {
    actionType(newVal) {
      if (newVal) {
        this.setCurrentStep(this.STEP_SELECT_ACTION);
      }
    },
    checkinActionType(newVal) {
      if (newVal) {
        this.setCurrentStep(this.STEP_SELECT_CHECKIN_ACTION);
      }
    },
  },
  computed: {
    isActionDetailsValid() {
      return this.receiptType !== -1
          && this.deliveryType !== -1
          && this.shipmentMethod !== -1;
    },
  },
  async mounted() {
    // fetch notifications & kept in store
    await this.$api.notification.list();

    const { order, actionType } = this.$route.params;
    if (order && actionType) {
      this.actionType = actionType;
      this.preSelectedOrder = order;
    }
  },
  methods: {
    setCurrentStep(step) {
      // change step to step - 1 => wait 50ms => change step to the actual value
      // so the change is always noticed by the HSrcoll component
      // HSroll will then scoll to the right, so the new view is visible to the user
      this.currentStep = step - 1;
      setTimeout(() => {
        this.currentStep = step;

        //
        // 1. PREPARE the data for each STEP
        // 2. RESET the data gathered from further steps
        //    so the data won't be mixed up
        //

        // RESET ANY PRE-SELECTED ORDER
        this.preSelectedOrder = null;

        // STEP 1
        if (step < this.STEP_SELECT_ACTION) {
          this.actionType = null;
        }
      }, 50);
    },
  },
  components: {
    CSSellList,
    CSAdminApprovalList,
    CSOutstandingList,
    CSBackOrderList,
  },
};
</script>

<style lang="scss">
.sell-records {
  > .h-scroll {
    height: 100%;
  }
}
</style>
